export default {
	themes: {
		light: 'ライト',
		dark: 'ダーク'
	}
};
